import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AdminLogin } from "./AdminPage";
import { api } from "../lib/api";

const ROLE_HOME = {
  admin: "/admin",
  welcome_coordinator: "/checkin",
  usher: "/checkin",
  room_manager: "/salon",
  viewer: "/admin",
  child_care_staff: "/cuidado-infantil",
  payment_reviewer: "/pagos",
};

const ALLOWED_REDIRECTS = {
  admin: ["/admin", "/checkin", "/salon", "/monitor", "/cuidado-infantil", "/pagos"],
  welcome_coordinator: ["/checkin", "/admin", "/salon", "/monitor", "/cuidado-infantil"],
  usher: ["/checkin"],
  room_manager: ["/salon"],
  viewer: ["/admin", "/monitor"],
  child_care_staff: ["/cuidado-infantil"],
  payment_reviewer: ["/pagos", "/admin"],
};

export const targetFor = (role, redirect) => {
  const home = ROLE_HOME[role] || "/";
  if (redirect && (ALLOWED_REDIRECTS[role] || []).some((r) => redirect.startsWith(r))) {
    return redirect;
  }
  return home;
};

const LoginPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const redirect = params.get("redirect");
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("hz_admin_token");
    if (!token) {
      setChecking(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => navigate(targetFor(r.data.role, redirect), { replace: true }))
      .catch(() => {
        localStorage.removeItem("hz_admin_token");
        setChecking(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-hz-bg text-hz-navy" data-testid="login-checking">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  return (
    <AdminLogin
      title="Acceso al sistema"
      footerLink
      onSuccess={(u) => navigate(targetFor(u.role, redirect), { replace: true })}
    />
  );
};

export default LoginPage;
